<template>
  <div>
    <FlipResult
      :table="table"
      :score="score"
      :state="state"
      style="top:500px;"
    />
    <!-- <Canvas :anim="'baccarat73'" :game-state="'LOCKING'"/> -->
  </div>
</template>

<script>
import FlipResult from '@components/baccarat/flip-result.vue';
import Canvas from "@components/common/canvas.vue";
import { GAMESTATE } from '@config/constants.js';
import { calculateChipStack } from '@utils/chip.js';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    FlipResult, Canvas
  },
  props: {
    name: { type: String, default: "" },
    table: { type: String, default: "" },
    tableId: { type: String, default: "" },
    data: { type: Object, default: () => ({})},
    styleObject: { type: Object, default: () => ({})},
  },
  data() {
    return {
      timeout: 0,
      gameState: GAMESTATE.LOADING,
      isHighlightResult: false,
      newRound: 0,
      timeBet: 0,
      jackpot: 0,
      odds: {},
      state: '',
      round: 12234,
      score: {
        playerCard1Number: "J",
        playerCard1Suit: 1,
        playerCard2Number: "K",
        playerCard2Suit: 2,
        playerCard3Number: "",
        playerCard3Suit: 3,
        playerCardTotal: 11,
        bankerCard1Number: 2,
        bankerCard1Suit: 4,
        bankerCard2Number: 3,
        bankerCard2Suit: 2,
        bankerCard3Number: "A",
        bankerCard3Suit: 3,
        bankerCardTotal: 10,
        result: "TIE",
        bigSmall: "BIG",
        double: "P_DUAL",
      },
    }
  },
  mounted() {
    const value = 1235;
    calculateChipStack(value);
  },
}
</script>

<style>

</style>
